export const MANAGE_ORDERS_TOKEN_SCOPE = 'manage_orders';
export const PLAN_ORDER_TOKEN_SCOPE = "plan_order";
export const PLACE_ECONOMY_ORDER_TOKEN_SCOPE = "place_economy_order";
export const MANAGE_BATCHES_TOKEN_SCOPE = "manage_batches";
export const MANAGE_CUSTOMERS_TOKEN_SCOPE = "manage_customers";
export const MANAGE_USERS_TOKEN_SCOPE = "manage_users";
export const MANAGE_PRODUCTS_TOKEN_SCOPE = "manage_products";